import AuthForm from '@/features/AuthForm/AuthForm.vue'
import PasswordRecovery from '@/features/PasswordRecovery/PasswordRecovery.vue'
import { computed, defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'AuthView',
  components: {
    AuthForm,
    PasswordRecovery,
  },
  setup() {
    const router = useRouter()
    const routeName = computed(() => router.currentRoute.value.name)

    const componentShown = computed(() => ({
      login: routeName.value === 'login',
      recovery: routeName.value === 'recovery',
      adminLogin: routeName.value === 'adminLogin',
    }))
    return { componentShown }
  },
})
